<div class="flex flex-col min-h-screen">
    <main class="min-w-full max-h-screen overflow-y-auto">
        <router-outlet></router-outlet>
    </main>
    <app-modal></app-modal>
    <app-toast></app-toast>
</div>
